module.exports = __webpack_public_path__ + "img/Triangle.a6e95235.svg";